import script from "./HbwlDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HbwlDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./HbwlDetailComponent.vue?vue&type=style&index=0&id=cacf3e26&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cacf3e26"]])

export default __exports__